import React from "react";
import Layout from "../../components/Layout/Layout";
import EraseAccountDataForm from "./EraseAccountDataForm";

const EraseAccountData = () => {
  return (
    <>
      <Layout>
        {/* Breadcrumb */}
        <div className="bred_crumb blog_detail_bredcrumb">
          <div className="container">
            <div className="bred_text">
              <h1>Erase Account Data</h1>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <section className="blog_detail_section">
          <div className="container">
            <div className="blog_inner_pannel plan-cancel">
              <div className="container">
                <h4>Erase Account Data</h4>
                <p className="mb-5">
                  You can request permanent deletion of your account data.
                  <br />
                  This action is irreversible and all associated data will be
                  permanently erased from our systems.
                </p>

                <h4 className="mb-4">Request Data Erasure</h4>
                <EraseAccountDataForm />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default EraseAccountData;
